import {ApplicationRef, Component, NgZone, OnInit, Renderer2} from '@angular/core';
import {SwUpdate} from '@angular/service-worker';
import {filter} from 'rxjs/operators';
import {NavigationEnd, Router, RouterEvent, NavigationStart} from '@angular/router';
import {PlatformLocation} from '@angular/common';
import {Location} from '@angular/common';
import {ApiService} from './services/api.service';
/**
 * Multilanguage Support 
 * Added by Harendra Singh Rawat 
 * Added on 01,Aug 2022
 ************************************************************************************************
 */
import { TranslateService } from '@ngx-translate/core'
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    message;
    previousUrl: string;
    // showModal = false;
    constructor(
        private api: ApiService, private swUpdate: SwUpdate,
        private zone: NgZone, location: PlatformLocation, public router: Router,
        private _location: Location, private applicationRef: ApplicationRef,
        private renderer: Renderer2,
        public translate: TranslateService
        ) {
            
             /* translate.addLangs(['en', 'ar']);
            translate.setDefaultLang('en');
            
        
            const browserLang = translate.getBrowserLang();
            translate.use(browserLang.match(/en|ar/) ? browserLang : 'en');  */
          //  this.translate.use(navigator.language); 
        router.events.subscribe((event: RouterEvent) => {
            if (event instanceof NavigationEnd) {
                this.zone.run(() => {
                    setTimeout(() => {
                        applicationRef.tick();
                    }, 500);
                });
            }
            if (event instanceof NavigationStart) {
          if (this.previousUrl) {
            this.renderer.removeClass(document.body, this.previousUrl);
          }
          const currentUrlSlug = event.url.slice(1);
          if (currentUrlSlug) {
            this.renderer.addClass(document.body, currentUrlSlug);
          } else {
            this.renderer.addClass(document.body, "home");
          }
          this.previousUrl = currentUrlSlug;
        }
            // this.navigationInterceptor(event);
        });

        // tariq sir
        // location.onPopState(() => {
        //     this.zone.run(() => {
        //         setTimeout(() => {
        //             applicationRef.tick();
        //         }, 500);
        //     });
        // });


        // location.onPopState(() => {
        //     this.zone.run(() => {
        //         const url = this.getUrl();
        //         this.api.navigate(url, '');
        //         // this.router.navigate([url]);
        //     });
        // });


    }

    ngOnInit() {
        if (this.swUpdate.isEnabled) {
            this.swUpdate.available.subscribe(() => {
                if (confirm('New version available. Load New Version?')) {
                    window.location.reload();
                }
            });
        }
    }

    getUrl() {
        const len = this._location.path().indexOf(';');
        let str = this._location.path();
        if (len !== -1) {
            str = (this._location.path().slice(0, (len)));
        }
        return str;
    }

}
